var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHidden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.47114 1.52827L14.492 13.5491C14.7523 13.8094 14.7523 14.2315 14.492 14.4919C14.2316 14.7522 13.8095 14.7522 13.5492 14.4919L11.5945 12.5373C10.5009 13.046 9.28317 13.3297 7.99974 13.3297C4.42561 13.3297 1.36121 11.129 0.0664062 7.99804C0.717255 6.42421 1.81523 5.08543 3.20032 4.14306L1.52833 2.47108C1.26799 2.21073 1.26799 1.78862 1.52833 1.52827C1.78868 1.26792 2.21079 1.26792 2.47114 1.52827ZM4.16336 5.1061C3.05641 5.80216 2.14 6.79584 1.53226 7.99804C2.75691 10.4206 5.23494 11.9964 7.99974 11.9964C8.90045 11.9964 9.77072 11.8292 10.5771 11.5199L9.838 10.7807C9.31104 11.1298 8.67913 11.333 7.99974 11.333C6.15879 11.333 4.66641 9.84062 4.66641 7.99967C4.66641 7.32029 4.86966 6.68837 5.21867 6.16141L4.16336 5.1061ZM7.99974 2.66634C11.5739 2.66634 14.6383 4.86706 15.9331 7.99804C15.4543 9.15569 14.7337 10.1862 13.8348 11.0252L12.8921 10.0825C13.5292 9.4959 14.0656 8.7925 14.4672 7.99804C13.2426 5.5755 10.7645 3.99967 7.99974 3.99967C7.62515 3.99967 7.25583 4.0286 6.89418 4.08464L5.77039 2.96085C6.48135 2.76876 7.22868 2.66634 7.99974 2.66634ZM7.99974 4.66634C9.84069 4.66634 11.3331 6.15872 11.3331 7.99967C11.3331 8.16556 11.321 8.32862 11.2976 8.48801L7.5114 4.70186C7.67079 4.67846 7.83385 4.66634 7.99974 4.66634Z",
    fill: "#505759"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidden);
export default __webpack_public_path__ + "static/media/hidden.92c4e0a3a556f0340238511cae941396.svg";
export { ForwardRef as ReactComponent };